<template>
  <div>
    <div class="d-flex align-items-center print-hidden ">
      <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-file" @click="printPage">
        پرینت
      </vs-button>
      <small>گزینه landscape را انتخاب کنید</small>
    </div>
    <div id="print-container" v-if="services">
      <div v-for="service in services">
        <service-card class="service-card" context="driver" :service="service"></service-card>
        <div class="page-break"></div>
      </div>
    </div>
    <div v-else>بدون سرویس</div>
  </div>
</template>

<script>
  import ServiceCard from "../../dashboard/components/ServiceCard";

  export default {
    name: "ServicesList",
    components: {ServiceCard},
    computed: {
      services() {
        return this.$store.state.services;
      }
    },
    methods: {
      printPage() {
        window.print()
      }
    }
  }
</script>

<style>

  @media print {

    .vx-navbar-wrapper, .vs-sidebar, .print-hidden {
      display: none;
    }

    .page-break {
      clear: both;
      page-break-after: always;
    }

    #content-area.content-area-reduced {
      margin: 0 !important;
    }
    .router-view{
      padding: 5px!important;
    }
  }

</style>
